/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskQueueItem
 */
export interface TaskQueueItem {
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    definitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    initiativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    dimensionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    dimensionKey?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    scheduleBlockId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    scheduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    cadenceTier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskQueueItem
     */
    evidenceRequired?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TaskQueueItem
     */
    scheduledFor?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TaskQueueItem
     */
    dueAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof TaskQueueItem
     */
    slaRemainingMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskQueueItem
     */
    overdue?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TaskQueueItem
     */
    lastCompletedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TaskQueueItem
     */
    blockStatus?: string;
}

/**
 * Check if a given object implements the TaskQueueItem interface.
 */
export function instanceOfTaskQueueItem(value: object): value is TaskQueueItem {
    return true;
}

export function TaskQueueItemFromJSON(json: any): TaskQueueItem {
    return TaskQueueItemFromJSONTyped(json, false);
}

export function TaskQueueItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskQueueItem {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'dimensionKey': json['dimensionKey'] == null ? undefined : json['dimensionKey'],
        'scheduleBlockId': json['scheduleBlockId'] == null ? undefined : json['scheduleBlockId'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'title': json['title'] == null ? undefined : json['title'],
        'cadenceTier': json['cadenceTier'] == null ? undefined : json['cadenceTier'],
        'evidenceRequired': json['evidenceRequired'] == null ? undefined : json['evidenceRequired'],
        'scheduledFor': json['scheduledFor'] == null ? undefined : (new Date(json['scheduledFor'])),
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'slaRemainingMinutes': json['slaRemainingMinutes'] == null ? undefined : json['slaRemainingMinutes'],
        'overdue': json['overdue'] == null ? undefined : json['overdue'],
        'lastCompletedAt': json['lastCompletedAt'] == null ? undefined : (new Date(json['lastCompletedAt'])),
        'blockStatus': json['blockStatus'] == null ? undefined : json['blockStatus'],
    };
}

export function TaskQueueItemToJSON(json: any): TaskQueueItem {
    return TaskQueueItemToJSONTyped(json, false);
}

export function TaskQueueItemToJSONTyped(value?: TaskQueueItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
        'definitionId': value['definitionId'],
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'dimensionId': value['dimensionId'],
        'dimensionKey': value['dimensionKey'],
        'scheduleBlockId': value['scheduleBlockId'],
        'scheduleId': value['scheduleId'],
        'title': value['title'],
        'cadenceTier': value['cadenceTier'],
        'evidenceRequired': value['evidenceRequired'],
        'scheduledFor': value['scheduledFor'] == null ? undefined : ((value['scheduledFor']).toISOString()),
        'dueAt': value['dueAt'] == null ? undefined : ((value['dueAt']).toISOString()),
        'slaRemainingMinutes': value['slaRemainingMinutes'],
        'overdue': value['overdue'],
        'lastCompletedAt': value['lastCompletedAt'] == null ? undefined : ((value['lastCompletedAt']).toISOString()),
        'blockStatus': value['blockStatus'],
    };
}

